import Alert from '@mui/material/Alert';

function ErrorText({styleClass, children, ...other}){
    return(
        <Alert severity="error" {...other}>{children}</Alert>
    )
}

export default ErrorText